import { ObjectWithId } from './../../util/object-with-id';
import * as Hogan from 'hogan.js';
import * as $ from 'jquery';

export class HtmlComponent extends ObjectWithId {
    public jqueryElement: JQuery;
    public parent: HtmlComponent;
    public isAddedToDom: boolean = false;
    public jqueryTag: string;

    constructor(private hogan: any, parameters: {}) {
        super();
        this.jqueryElement = this.compileTemplate(hogan, parameters);
    }

    public addToParent = (parent: HtmlComponent): HtmlComponent => {
        this.appendToParent(parent.jqueryElement);
        this.parent = parent;
        this.jqueryTag = null;
        return this;
    }

    public addToJqueryTag(jqueryTag: string, parentScope?: HtmlComponent) {
        this.parent = parentScope;
        this.jqueryTag = jqueryTag;
        if (parentScope) {
            let parentElement = $(parentScope.jqueryElement).find(jqueryTag);
            if (parentElement.length > 0) {
                this.appendToParent(parentElement);
            } else {
                throw new Error(
                    'Parent Element is not found for jqueryTag: ' + jqueryTag + ' and parentscope: ' + parentScope
                );
            }
        } else {
            let parentElement = $(jqueryTag);
            if (parentElement.length > 0) {
                this.appendToParent(parentElement);
            } else {
                throw new Error(
                    'Parent Element is not found for jqueryTag: ' + jqueryTag + ' and parentscope: ' + parentScope
                );
            }
        }
        this.parent = parentScope;
    }

    private appendToParent(parentElement: JQuery) {
        this.isAddedToDom = true;
        parentElement.append(this.jqueryElement);
    }

    public compileTemplate(hogan: any, parameters: {}) {
        let compiled = Hogan.compile(hogan);
        return $(compiled.render(parameters));
    }

    public reapplyTemplate = (parameters: any) => {
        let old = this.jqueryElement;
        this.jqueryElement = this.compileTemplate(this.hogan, parameters);
        if (this.isAddedToDom) {
            old.detach();
            if (this.jqueryTag) {
                this.addToJqueryTag(this.jqueryTag, this.parent);
            } else {
                this.addToParent(this.parent);
            }
        }
    }
}
